import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

export const svgStyle = recipe({
  base: {
    width: "100%",
    height: "100%",
    transform: "rotate(-90deg)",
  },
  variants: {
    absolute: {
      true: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
  },
});

export const trackStyle = recipe({
  variants: {
    variant: {
      default: {
        stroke: theme.colors.defaultBorder,
      },
      opaque: {},
    },
  },
});

export const progressStyle = recipe({
  variants: {
    variant: {
      default: {
        stroke: theme.colors.primary,
      },
      opaque: {
        stroke: theme.colors.primary,
      },
    },
  },
});
